import { useRouter } from "next/router";

import classNames from "classnames";

import CustomCard from "components/CustomCard";
import ProfileSnippet from "components/ProfileSnippet";
import { useApi } from "hooks/useApi";
import useMediaQuery from "hooks/useMediaQuery";
import { ApiEndpoint, baseFetcher } from "utils/baseFetcher";

import styles from "./style.module.scss";

type EntityPageRelatedIPProps = { card?: boolean; widget?: boolean };

export const entityRelatedIPUrl = (slug: string, pageIndex: number) => {
  const url = new ApiEndpoint(`/api/v2/entities/${slug}/related-ip-accounts`);
  url.searchParams.append("include", "company");
  url.searchParams.append("filter[relation-type]", "wrote-insights");
  url.searchParams.append("page[size]", "12");
  url.searchParams.append("page[number]", `${pageIndex}`);
  url.searchParams.append("sort", "-ip-rank");

  return url.href;
};

const EntityPageRelatedIP = ({ card, widget }: EntityPageRelatedIPProps) => {
  const route = useRouter();
  const slug = route.query.slug as string;

  const { mobile } = useMediaQuery();

  const { data } = useApi(entityRelatedIPUrl(slug, 1), baseFetcher);

  if (!data?.data?.length) return <></>;

  const content = (
    <div
      className={classNames(styles.container, mobile && styles.mobileLayout)}
    >
      <div className={styles.title}>Related Providers</div>
      <div className={classNames(styles.list, card && styles.card)}>
        {data?.data?.map?.((profile: any) => (
          <ProfileSnippet
            key={profile.id}
            profile={profile}
            showFollowButton
            card={card}
          />
        ))}
      </div>
    </div>
  );

  if (widget) {
    return <CustomCard className={styles.card}>{content}</CustomCard>;
  }

  return content;
};

export default EntityPageRelatedIP;
